




































import TemplateContent from "./templateContent.vue";
import Identification from "./identification.vue";
import Preview from "./preview.vue";
import Submit from "./submit.vue";
import Save from "./save.vue";
// @ts-ignore
import { required } from "@validations";
// @ts-ignore
import i18n from "@/libs/i18n";
import { computed, defineComponent, PropType, ref, watchEffect } from "@vue/composition-api";
import { TemplateInterface, TemplateStatus } from "@/interfaces/template.interface";
import { extend, ValidationObserver } from "vee-validate";
import { diff } from "@/utils/luxon";
import { BContainer } from "bootstrap-vue";

export default defineComponent({
    components: {
        TemplateContent,
        Identification,
        Preview,
        Save,
        Submit,
        ValidationObserver,
        BContainer,
    },
    directives: {},
    props: {
        lockMetadata: {
            required: false,
            type: Boolean,
        },
        createForm: {
            required: false,
            type: Boolean,
        },
        isSaving: {
            required: false,
            type: Boolean,
        },
        isSubmitting: {
            required: false,
            type: Boolean,
        },
        value: {
            required: true,
            type: Object as PropType<TemplateInterface>,
        },
    },
    data() {
        return {
            required,
        };
    },
    setup(props, { emit }) {
        const template = computed<TemplateInterface>({
            get: () => props.value,
            set: (value) => emit("input", value),
        });

        extend("no-emoji", {
            validate: (text) => !text.match(/\p{Emoji_Presentation}/u),
            message: (field) => i18n.t("validation.no-emoji", { field }),
        });

        extend("no-variables", {
            validate: (text) => !text.match(/\{\{[^}]+}}/),
            message: (field) => i18n.t("validation.no-variables", { field }),
        });

        const templateValidator = ref<InstanceType<typeof ValidationObserver>>();

        const submit = (submitForReview = false) => {
            templateValidator.value?.validate().then((success) => {
                if (!success) {
                    return;
                }
                emit("submit", template.value, submitForReview);
            });
        };

        const isSubmittable = computed(() => {
            if (template.value.status === TemplateStatus.PENDING) {
                return false;
            }

            // If approved status, then check if it was within last 24h. If so, you cannot edit it again.
            return !(
                diff(new Date().toISOString(), template.value.submittedAt ? template.value.submittedAt : "1970-1-1")
                    .milliseconds < 86400000
            );
        });

        const isTemplateValid = ref(false);

        watchEffect(async () => {
            if (template.value.components?.examples?.map((example) => example.trim()).includes("")) {
                isTemplateValid.value = false;
                return;
            }

            const info = await templateValidator.value?.validateWithInfo();
            isTemplateValid.value = info?.isValid ?? true;
        });

        const identificationIsDirty = ref(false);
        const templateContentIsDirty = ref(false);

        const isSubmitDisabled = computed(() => {
            if (!isTemplateValid?.value || !isSubmittable.value) {
                return true;
            }
            if (template.value?.submittedAt) {
                return !templateContentIsDirty.value;
            }
            return false;
        });

        const isSaveDisabled = computed(() => {
            if (!isTemplateValid?.value) {
                return true;
            }
            if (template.value?.submittedAt) {
                return templateContentIsDirty.value;
            }

            return false;
        });

        return {
            templateValidator,
            template,
            submit,
            isSubmitDisabled,
            isSaveDisabled,
            isSubmittable,
            templateContentIsDirty,
            identificationIsDirty,
        };
    },
});
